<div class="mv-10">
  <h4>{{ 'form-builder.element-type.membership-level.membership-level-properties' | translate | titlecase }}</h4>
  <div>{{ 'form-builder.element-type.membership-level.helper-text' | translate }}</div>

  <select class="form-control" [(ngModel)]="selectedMemberShipLevel" (ngModelChange)="membershipLevelSelected()">
    <option [ngValue]="null">{{ 'form-builder.element-type.membership-level.dropdown-placeholder' | translate }}</option>
    <option *ngFor="let field of _allFields" [ngValue]="field">{{ field.Name }}</option>
  </select>
</div>

<div cdkDropList (cdkDropListDropped)="sortMembershipLevel($event)" class="field-selector-grid">
  <div class="field-header" style="display: flex;">
    <div class="right-border" style="width: 50px; flex-shrink: 0;"></div>
    <div class="right-border" style="flex: 1;">
      <div class="ml-9 mt-9 mb-9 f-wb">
        {{ 'form-builder.element-type.membership-level.membership-level-properties' | translate | titlecase }}
      </div>
    </div>
    <div class="right-border" style="flex: 1;">
      <div class="ml-9 mt-9 mb-9 f-wb">
        {{ 'form-builder.element-type.membership-level.label-header' | translate | titlecase }}
      </div>
    </div>
    <div style="width: 80px; flex-shrink: 0;"></div>
  </div>
  <div class="scroll-y">
    <div cdkDrag class="field-container" *ngFor="let membershipLevelField of membershipLevelSettings.MembershipLevelOptions; let i = index">
      <div class="field-row" style="display: flex; align-items: center;">
        <div class="wc-movable right-border" style="width: 50px; flex-shrink: 0;">
          <span class="grip"></span>
        </div>
        <div class="right-border" style="flex: 1;">
          <div class="ml-9 mt-15 mb-15">
            {{ membershipLevelField.Name }}
          </div>
        </div>
        <div class="right-border" style="flex: 1;">
          <div class="ml-9 mr-9 mt-9 mb-9">
            <input
              class="form-control"
              type="text"
              [(ngModel)]="membershipLevelField.LabelText"
              placeholder="{{ membershipLevelField.Name }}"
            />
          </div>
        </div>
        <div style="width: 80px; flex-shrink: 0; display: flex; align-items: center; justify-content: center;">
          <a (click)="removeMembershipLevel(i)"> {{ 'common.remove' | translate | uppercase }} </a>
        </div>
      </div>
    </div>
  </div>
</div>
